import {
  AGGREGATOR_SAVE,
  AGGREGATOR_UPDATE,
  GET_ALL_AGGREGATOR,
  GET_ALL_PRIVILAGES,
  GET_ALL_PRIVILAGES_BY_ID,
  MASTER_MERCHANT_ENABLE_DISABLE,
} from "../utils/constant";

export const masterMerchantService = (api) => ({
  getAll: () => api.apiCallFnforGet(GET_ALL_AGGREGATOR),
  getById: (id) => api.apiCallFnforGet(`${GET_ALL_AGGREGATOR}/${id}`),

  create: (payload) => api.apiCallFnforPost(AGGREGATOR_SAVE, payload),
  update: (payload) => api.apiCallFnforPut(AGGREGATOR_UPDATE, payload),

  toggleStatus: (id, action) =>
    api.apiCallFnforPut(`${MASTER_MERCHANT_ENABLE_DISABLE}${action}/${id}`, ""),

  getPrivileges: () => api.apiCallFnforGet(GET_ALL_PRIVILAGES),
  getPrivilegesById: (id) =>
    api.apiCallFnforGet(`${GET_ALL_PRIVILAGES_BY_ID}/${id}`),
});
